// PaymentForm.tsx — финальная версия
import React from 'react'
import classes from './PaymentForm.module.sass'
import { usePaymentForm } from './usePaymentForm'
import { usePaymentData } from '../../../common/hooks/usePaymentData'
import { Loader } from '../../../common/components/loader/Loader'
import { YooKassa } from '../paymentForm/components/yooKassa/YooKassa'
import { Button } from '../../../common/components/button/Button'

type Props = {
  clusterId: number
  onSuccess?: () => void
}

export const PaymentForm = ({ clusterId, onSuccess }: Props) => {
  const { loading, tariff, monthlyPrice, agreement, error } = usePaymentData(clusterId)

  const {
    paymentLoading,
    invoiceLoading,
    yoomoneyToken,
    paymentId,
    startPayment,
    requestInvoice,
    selectedDuration,
    setSelectedDuration,
    availableDurations,
    price,
  } = usePaymentForm({
    clusterId,
    tariff,
    monthlyPrice,
    agreement,
  })

  const handleRequestInvoice = async () => {
    try {
      await requestInvoice()
      onSuccess?.()
    } catch {
      onSuccess?.()
    }
  }

  return (
    <div className={classes.Container}>
      {loading ? (
        <Loader />
      ) : error ? (
        <div className={classes.Error}>{error}</div>
      ) : yoomoneyToken ? (
        <YooKassa
          yoomoneyToken={yoomoneyToken}
          paymentId={String(paymentId)}
          onSuccess={onSuccess}
        />
      ) : paymentLoading || invoiceLoading ? (
        <Loader />
      ) : (
        <>
          <div className={classes.Title}>Оплата кластера</div>

          <div className={classes.DurationSelector}>
            {availableDurations.map((months) => {
              const discount = tariff?.discounts?.find((d) => d.durationMonths === months)
              return (
                <button
                  key={months}
                  className={selectedDuration === months ? classes.Active : ''}
                  onClick={() => setSelectedDuration(months)}
                >
                  {months} мес.
                  {discount && (
                    <span className={classes.Discount}>-{discount.discountPercent}%</span>
                  )}
                </button>
              )
            })}
          </div>

          <div className={classes.Amount}>{price} ₽</div>
          <div className={classes.Description}>
            {selectedDuration === 1
              ? `Ежемесячная плата: ${monthlyPrice} ₽`
              : `Оплата за ${selectedDuration} месяцев со скидкой`}
          </div>

          <div className={classes.ButtonGroup}>
            <Button text="Оплатить" onClick={startPayment} />
            <Button
              text="Получить счёт"
              onClick={handleRequestInvoice}
              disabled={invoiceLoading}
            />
          </div>
        </>
      )}
    </div>
  )
}